interface UserInterface {
    id: number;
    created: string;
    updated: string;
    username: string;
    password: string;
    isActive: boolean;
    isHidden: boolean;
    companyId: number;
    roleId: number;
}

interface PreferencesInterface {
    languages: number[];
}

class Preferences implements PreferencesInterface {
    languages: number[] = [];
}

class User implements UserInterface
{
    created: string;
    id: number = null;
    isActive: boolean = true;
    isHidden: boolean;
    password: string;
    companyId: number = null;
    roleId: number = null;
    updated: string;
    username: string;
    preferences: Preferences = new Preferences();
}

export {
    UserInterface,
    User,
    PreferencesInterface,
    Preferences
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/users/api.models.ts